import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import AuthFooter from './authFooter';
import AuthCard from './authCard';
import { ThemeProvider } from '@mui/material/styles';
import LogoArparinavy from "../../style/frontpage/img/arpari-logos/Logo-Arpari-navy.png";
import theme from "../../helpers/theme";
import AuthBackground from './authBackground';


export default function AuthWrapper({ children }) {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ minHeight: '100vh' }}>
        <AuthBackground />
        <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
          <Grid item xs={12}>
            <a href="https://www.arpari.com/" style={{ margin: "70px 0 15px 50px" }}>
              <img src={LogoArparinavy} width="150px" alt="Arpari" />
            </a>
          </Grid>
          <Grid item xs={12}>
            <Grid
              item
              xs={12}
              container
              justifyContent="center"
              alignItems="center"
              sx={{ minHeight: { xs: 'calc(100vh - 210px)', sm: 'calc(100vh - 134px)', md: 'calc(100vh - 112px)' } }}
            >
              <Grid item>
                <AuthCard>{children}</AuthCard>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
            <AuthFooter />
          </Grid>
        </Grid>
      </Box>
    </ThemeProvider>
  );
}

AuthWrapper.propTypes = { children: PropTypes.node };